var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrentLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4047 0.275549C16.7251 0.471203 16.8998 0.837595 16.85 1.20969L14.5405 18.4728C14.4711 18.9914 13.9945 19.3556 13.4759 19.2862C12.9573 19.2168 12.5932 18.7402 12.6625 18.2216L14.6871 3.08837L3.27838 11.0173L7.22108 12.5998L10.4428 8.6863C10.7754 8.28236 11.3724 8.22448 11.7764 8.55701C12.1803 8.88955 12.2382 9.48658 11.9056 9.89052L8.24314 14.3394C7.98071 14.6582 7.54204 14.7703 7.15885 14.6165L0.942136 12.1212C0.618888 11.9915 0.392912 11.6948 0.353695 11.3487C0.314479 11.0026 0.46835 10.6629 0.754373 10.4641L15.3704 0.306144C15.6786 0.0918959 16.0843 0.0798959 16.4047 0.275549Z",
    fill: "#1D1D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6133 16.1043C11.3517 16.5574 10.7723 16.7126 10.3192 16.451C9.86606 16.1894 9.71082 15.61 9.97242 15.1569C10.234 14.7038 10.8134 14.5485 11.2665 14.8102C11.7196 15.0718 11.8749 15.6512 11.6133 16.1043Z",
    fill: "#1D1D38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/currentLocation.557f00ec.svg";
export { ForwardRef as ReactComponent };